module.exports = __webpack_public_path__ + "img/history.4139e178.png";